// extracted by mini-css-extract-plugin
export default {"profile":"style_profile__3b4BC","slidedown":"style_slidedown__hWdCc","logout":"style_logout__yzdP9"};